document.addEventListener('DOMContentLoaded', function () {
  const onetimeOption = document.getElementById('purchase_option_onetime');
  const subOption = document.getElementById('purchase_option_subsave');
  const priceDisplay = document.querySelector('.price__regular .price-item--regular');
  const sellingPlanSelect = document.getElementById('selling_plan_select');
  let sellingPlanInput = document.querySelector('input[name="selling_plan"]');

  // If the hidden input doesn't exist, create and append it
  if (!sellingPlanInput) {
    sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    subOption.closest('form').appendChild(sellingPlanInput);
  }

  function updateSubscriptionPrice() {
    const selectedPrice = subOption.getAttribute('data-price');
    if (priceDisplay && selectedPrice) {
      priceDisplay.textContent = selectedPrice;
    }

    const selectedOption = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
    const sellingPlanId = selectedOption.getAttribute('data-id');
    if (sellingPlanId) {
      sellingPlanInput.value = sellingPlanId;
    }
  }

  // When switching between purchase options
  document.querySelectorAll('input[name="purchase_option"]').forEach((radio) => {
    radio.addEventListener('change', function () {
      if (this.id === 'purchase_option_subsave') {
        updateSubscriptionPrice();
      } else {
        // Reset price display and hidden input if needed
        const regularPrice = onetimeOption.getAttribute('data-price');
        if (priceDisplay && regularPrice) {
          priceDisplay.textContent = regularPrice;
        }
        sellingPlanInput.value = '';
      }
    });
  });

  // Update selling plan input when user changes the dropdown
  sellingPlanSelect.addEventListener('change', function () {
    if (subOption.checked) {
      updateSubscriptionPrice();
    }
  });

  // Initialize on load if sub option is selected
  if (subOption.checked) {
    updateSubscriptionPrice();
  }
});